import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';

import { CloseOutlineIcon } from '@/assets/icons/v2';

import { PreviousArrow } from '../styles';
import { NavButton } from './styles';

const FOOTER_GUTTER = 16;

interface FooterProps {
	previousDisabled: boolean;
	onPrevious: () => void;
	onClose: () => void;
}

export function Footer({ previousDisabled, onPrevious, onClose }: Readonly<FooterProps>): JSX.Element {
	return (
		<Row justify="center" gutter={[FOOTER_GUTTER, 0]}>
			<Col>
				<NavButton
					icon={<PreviousArrow />}
					disabled={previousDisabled}
					aria-label={I18n.get('Previous')}
					onClick={onPrevious}
				/>
			</Col>
			<Col>
				<NavButton icon={<CloseOutlineIcon />} aria-label={I18n.get('Close')} onClick={onClose} />
			</Col>
		</Row>
	);
}
